import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  url: string;
}

interface NavigationPage { title: string; link: string; }

@Component({
  selector: 'app-assurance-locaux-professionnels',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-locaux-professionnels.component.html',
  styleUrls: ['./assurance-locaux-professionnels.component.scss']
})
export class AssuranceLocauxProfessionnelsComponent {
  title = 'Assurance Loueur de Véhicules';
  subtitle = 'Protégez votre activité de location avec l\'assurance adaptée aux loueurs de véhicules et auto-écoles';
  heroImage = 'assets/static_pages_images/auto-peso.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', url: '' },
    { label: 'Assurance Loueur de Véhicules', url: '' }
  ];

  prevPage: NavigationPage = { 
    title: 'Assurance Flotte Moto Professionnelle', 
    link: '/assurance-flotte-moto-professionnelle'
  };

  nextPage: NavigationPage = { 
    title: 'Assurance Marchandises Transportées', 
    link: '/assurance-marchandises-transportees'
  };
}
